<template>
  <div>
    <b-alert v-model="hasUnknownError" variant="danger">
      {{ unknownErrorMessage }}
    </b-alert>

    <b-form-group>
      <b-form-select
        v-model="applicationType"
        :options="applicationTypes"
        :disabled="isModalEdit"
      >
        <template v-slot:first>
          <b-form-select-option :value="null">Massnahme auswählen</b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group>

    <guidance
      v-if="applicationType"
      :applicationType="applicationType"
      :communityId="advancedCommunityId"
    />

    <b-button variant="primary" @click="onSubmit" v-if="applicationType">
      Weiter
    </b-button>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { errorHandler } from '@/helpers/formHelper.js'
  import Guidance from '@/components/application/Intro/Guidance.vue'

  export default {
    data: () => ({
      hasUnknownError: false,
      unknownErrorMessage: '',
      applicationTypes: []
    }),
    created () {
      this.getApplicationTypes()
    },
    methods: {
      async getApplicationTypes () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('application/GET_APPLICATION_ADVANCED_TYPES').then(res => {
          const { errors, data } = res

          if (errors) {
            return errorHandler(this, errors)
          }

          const applicationTypes = data.gesuchsArten

          const renamedTypes = applicationTypes.map(type => ({
            text: type.bezeichnung,
            title: type.bezeichnung,
            abkuerzung: type.abkuerzung,
            value: type.abkuerzung
          }))

          this.applicationTypes = renamedTypes
        }).catch(err => {
          this.hasUnknownError = true
          console.error(err)
        })
      },
      async onSubmit () {
        let typeName = null
        const applicationType = this.applicationTypes
          .filter(applicationType => applicationType.value === this.applicationType)

        if (Array.isArray(applicationType) && applicationType.length) {
          typeName = applicationType[0].text
        }

        this.$store.commit('application/SET_APPLICATION_TYPE_NAME', typeName)
        this.$store.commit('application/SET_APPLICATION_ADVANCED_FINAL')

        this.$router
          .push({
            name: 'uebersicht',
            params: {
              modalMethod: this.isModalEdit ? 'bearbeiten' : 'erstellen',
              tabName: 'kontaktdaten'
            }
          })
          .catch(() => {})
      }
    },
    props: {
      isModalEdit: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      ...mapState({
        advancedCommunityId: state => state.application.createApplication.advancedCommunityId
      }),
      applicationType: {
        set (value) {
          this.$store.commit('application/SET_APPLICATION_ADVANCED_TYPE', value)
        },
        get () {
          return this.$store.state.application.createApplication.applicationAdvancedType
        }
      }
    },
    watch: {
      advancedCommunityId (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.getApplicationTypes()
        }
      }
    },
    components: {
      Guidance
    }
  }
</script>
